var fakeData = require('./fake.json');
module.exports = {
  fetchData: function(cb) {
    var getJSON = function(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'json';
      xhr.onload = function() {
        var status = xhr.status;
        if (status == 200) {
          callback(null, xhr.response);
        } else {
          callback(null, fakeData);
        }
      };
      xhr.send();
    };

    //getJSON('https://infoviz-fakenews.firebaseapp.com/infoviz-fakenews-fakenews-export.json', function(error, data) {
    getJSON('https://infoviz-fakenews.firebaseapp.com/fake.json', function(error, data) {
      // if (!error) {
      //   cacheJS.set('data', data);
      // }
      cb(error, data);
    });
  }
}



// WEBPACK FOOTER //
// ./src/data.js